export const theme = {
    colors: {
        primary: '#3347CC',
        white: '#FFFFFF',
        secondary: '#3f55c4',
        gray: '#818797',
        red: 'red'
    },
    components: {
        buttons: {},
        inputs: {
            typography: {
                fontFamily: 'Montserrat'
            }
        }
    }
};
